<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="12" class="mt-2">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-btn class="mr-1" color="primary" @click.prevent="showCreatePanel()" outlined
                style="margin-left: auto;">
                <v-icon class="pr-2">fa-plus</v-icon>New Release Notes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
          <v-data-table :headers="headers" :options.sync="options" :server-items-length="serverItemsLength"
          v-show="!loading" :items="releaseUpdates" item-key="id">

            <template v-slot:item.id="{ item }" >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="item.state == 4" :id="item.id" v-on="on" outlined small color="secondary" class="ml-1"
                    @click.prevent="showEditPanel(item.id)">
                    <v-icon small>fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <span>Edit Release Notes</span>
              </v-tooltip>

               <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="item.state == 4" :id="item.id" v-on="on" outlined small color="secondary" class="ml-1"
                    @click.prevent="deleteReleaseUpdates(item.id)">
                    <v-icon small>fa-trash-alt</v-icon>
                  </v-btn>
                </template>
                <span>Delete Release Notes</span>
              </v-tooltip>
              
              
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import SuperAdminLayout from '@/layouts/SuperAdmin';
import superAdminAPI from '@/api/superadmin.js';
import NewRelease from '@/components/superadmin/releaseupdates/Create';

export default {
  name: 'ReleaseUpdates',
  components: {
    SuperAdminLayout,
  },
  data() {
    return {
      headers: [
        { text: 'Title', value: 'title', sortable: false },
        {
          text: "Release Date",
          value: "release_date_formatted",
          sortable: false
        },
        {
          text: "Created",
          value: "created_at"
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
     
      releaseUpdates: [],
      pagination: {},
      options: {},
      loading: false,
      loginLoading: false,
      confirmDelete: 'Are you sure you want to delete this release notes?',
      successMessage: 'Release notes successfully deleted.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
    };
  },
  computed: {
     serverItemsLength: function () {
      if (this.pagination && this.pagination.total) {
        return this.pagination.total;
      } else {
        return this.releaseUpdates.length;
      }
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
  },  
  watch: {
    options: {
      handler() {
        this.getReleaseUpdates();
      },
      deep: true,
    },
  },
  methods: {
    showCreatePanel(){
        this.$showPanel({
        component: NewRelease,
        openOn: 'right',
      });
    },
    showEditPanel(id){
      this.$showPanel({
        component: NewRelease,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    getReleaseUpdates(){
      this.loading = true;
      superAdminAPI
        .getAllReleases(this.params)
        .then((resp) => {
          this.releaseUpdates = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    deleteReleaseUpdates(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.deleteReleaseUpdatesProcess(toast, id)
          }
        ],
      });
    },
     deleteReleaseUpdatesProcess(toast, id) {
       this.$snotify.remove(toast.id);
      this.loading = true;
        superAdminAPI.deleteReleaseUpdates(id)
          .then(() => {
            this.$snotify.success(this.successMessage);
            setTimeout(() => {
              this.$gf.removeBackdrop();
            },300);
            this.getReleaseUpdates()
          })
          .catch((err) => {
            this.$snotify.error(this.errorMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
          });
    },
    setEventBus() {
      EventBus.$on('RELEASE_UPDATED', () => {
        this.getReleaseUpdates();
      });
    },
  },
};
</script>
